exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-action{cursor:pointer}.list-action small{width:16px;height:16px;margin-right:16px;display:inline-block}.list-action small img{max-width:100%;height:16px}.table-categ-question{margin-bottom:0}.table-categ-question thead tr th{padding:10px;text-align:left;font:Bold 15px/18px Helvetica;letter-spacing:0;color:#343a40;opacity:1}.table-categ-question thead tr th .fa-sort-alpha-down{margin-left:10px;cursor:pointer}.table-categ-question thead tr th .fa-sort-alpha-down.checked{color:#219aff}.table-categ-question tbody tr td{text-align:left!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56b47599","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Question/Category/tbCateQuestion.vue
// module id = 1095
// module chunks = 0